import React from 'react';
import { DashboardCard } from '../DashboardCard';

/**
 * Web Teams View Dashboard Card
 * Wrapper around shared DashboardCard with web variant
 */
const WebTeamsViewDashboardCard = ({ homepage, setDialog, teamId }) => {
  return (
    <DashboardCard
      dashboard={homepage}
      setDialog={setDialog}
      teamId={teamId}
      variant="web"
      showHoverActions={true}
    />
  );
};

export default WebTeamsViewDashboardCard;
